/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { type BodyOf, tasksV1CommentsUpdateCreate } from '../fetch-client';
import { GetTask } from '../queries/get-task';
import { useFetchOpts } from '../use-fetch-opts';

export namespace UpdateTaskComment {
  export type Input = {
    id: string;
    content: string;
    taskId: string;
  };
  export type Output = void;

  function bodyFromInput({
    id,
    content,
  }: Input): BodyOf<typeof tasksV1CommentsUpdateCreate> {
    return {
      uuid: id,
      updateCommentViewInputRequest: {
        content,
      },
    };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();
    const queryClient = rq.useQueryClient();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        await ok(tasksV1CommentsUpdateCreate(body, opts));
        return;
      },
      async onSuccess(_, input) {
        await queryClient.invalidateQueries({
          queryKey: GetTask.key({ id: input.taskId }),
        });
      },
    });
  }
}
